import { render, staticRenderFns } from "./NavButton.vue?vue&type=template&id=1514cb92&scoped=true"
import script from "./NavButton.vue?vue&type=script&lang=ts"
export * from "./NavButton.vue?vue&type=script&lang=ts"
import style0 from "./NavButton.vue?vue&type=style&index=0&id=1514cb92&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1514cb92",
  null
  
)

export default component.exports